import { AbstractApiModel } from './abstract-api-model';

/**
 * Slim RobotEscalation projection returned by the server-side idle endpoints.
 *
 * The idle threshold, the snooze-expiry check and the "new since last seen" determination are all
 * owned by the backend, so this model intentionally carries no logic beyond deserialization.
 */
export class IdleRobotEscalation extends AbstractApiModel<IdleRobotEscalation> {
  robotId: number;
  robotName: string;
  status: string;
  priority: number;
  snoozeUntil: Date;
  assignedTo: number;
  idleSince: Date;
  isNew: boolean;
  eventsCount: number;

  deserialize(json: any): this {
    this.robotId = json.robot?.id;
    this.robotName = json.robot?.name;
    this.status = json.status;
    this.priority = json.priority;
    this.snoozeUntil = json.snooze_until && new Date(json.snooze_until);
    this.assignedTo = json.assigned_to;
    this.idleSince = json.idle_since && new Date(json.idle_since);
    this.isNew = !!json.is_new;
    this.eventsCount = json.events_count ?? 0;

    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      status: this.status,
      assigned_to: this.assignedTo ?? null,
      snooze_until: this.snoozeUntil
    });
  }
}

export interface IdleRobotEscalationCount {
  count: number;
  newCount: number;
  idleMinutes: number;
}
